// @flow
import * as React from 'react';
// $FlowIssue
import { useRef } from 'react';
import { ModalPortal } from 'components/Modal';
import { XIcon } from 'components/Icons/XIcon';
import styles from './MediaUploadModal.module.scss';
import ClickOutside from 'react-click-outside';

function Backdrop(props) {
  return (
    <div className="fixed left-0 right-0 bottom-0 top-0 bg-black-60 flex flex-row items-center justify-around z-max">
      {props.children}
    </div>
  );
}

type MediaUploadModalProps = {
  body: React.Node,
  footer: React.Node,
  onClose: () => void,
};
export function MediaUploadModal(props: MediaUploadModalProps) {
  const { body, footer, onClose } = props;
  const container = useRef();

  return (
    <ModalPortal>
      <Backdrop>
        <ClickOutside
          onClickOutside={e => {
            e.stopPropagation();
            onClose();
          }}
        >
          <div
            ref={container}
            className={styles['mu-modal']}
            onKeyDown={e => {
              if (e.key === 'Escape') {
                e.stopPropagation();
                e.preventDefault();
                onClose();
              }
            }}
          >
            <button
              type="button"
              className="input-reset b--none bg-transparent pa1 absolute top-0 right-0"
              onClick={onClose}
              aria-label="Close Modal"
            >
              <XIcon
                className="db gray ma1"
                style={{
                  width: 22,
                  height: 22,
                  strokeLinecap: 'round',
                  strokeWidth: 4,
                  stroke: 'currentColor',
                }}
              />
            </button>
            <div className={styles['mu-modal__body']}>{body}</div>
            <div className={styles['mu-modal__footer']}>{footer}</div>
          </div>
        </ClickOutside>
      </Backdrop>
    </ModalPortal>
  );
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/MediaUpload/MediaUploadModal.js